import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import BonusRules from "../components/financeComponent/bonusRulesComponent";
import Footer from "../components/footerComponent/footer";
import React from "react";

export default function BonusRulesPage() {
    return (
        <Layout>
            <Header/>
            <BonusRules/>
            <Footer/>
        </Layout>
    );
}